import { LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  className?: string;
}

const FeatureCard = ({ icon: Icon, title, description, className = '' }: FeatureCardProps) => {
  return (
    <div
      className={`group p-7 rounded-2xl border border-slate-200 bg-white hover:border-primary-300 hover:shadow-[0_12px_32px_rgba(15,23,42,0.08)] transition-all duration-200 ${className}`}
    >
      <div className="w-11 h-11 rounded-xl bg-primary-50 group-hover:bg-primary-100 flex items-center justify-center mb-5 transition-colors">
        <Icon className="w-5 h-5 text-primary-700" />
      </div>
      <h3 className="text-base font-semibold text-slate-900 mb-2 leading-snug">{title}</h3>
      <p className="text-sm text-slate-600 leading-relaxed">{description}</p>
    </div>
  );
};

export default FeatureCard;
